const BASIC_URL = "http://krishnasteelforge.com/";

export const config = {
    PUBLIC_URL: BASIC_URL,
};

export default config;